import React from 'react';
import styled from 'styled-components';
import { ColorUtils, GetColor, PRIVATE_ASSET_CASH_FLOW_HELP_HREF, Tooltip } from 'venn-ui-kit';

const PrivatesCashflowPacingSettingsTooltip = () => {
  return (
    <Wrapper>
      <Tooltip block usePortal content={'Click the "..." next to any private asset subject in the Inputs panel'}>
        <TooltipButton>CF Pacing model parameter settings</TooltipButton>
      </Tooltip>
      <HelpText>
        To learn more about how Cash Flow Pacing Model Parameters work,{' '}
        <a target="_blank" rel="noopener noreferrer" href={PRIVATE_ASSET_CASH_FLOW_HELP_HREF}>
          visit the FAQ
        </a>
        .
      </HelpText>
    </Wrapper>
  );
};

const Wrapper = styled.div``;
const TooltipButton = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  color: ${GetColor.Primary.Dark};
  border: 1px solid ${GetColor.Primary.Dark};
  background-color: ${ColorUtils.opacifyFrom(GetColor.Primary.Dark, 0.1)};
  border-radius: 4px;
  padding: 8px;
  font-weight: bold;
  text-align: center;
`;
const HelpText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${GetColor.GreyScale.Grey70};
`;

export default PrivatesCashflowPacingSettingsTooltip;
